import { render, staticRenderFns } from "./LoadingType.vue?vue&type=template&id=248589ce&"
import script from "./LoadingType.vue?vue&type=script&lang=js&"
export * from "./LoadingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports